import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { api, mapApiError } from '../../../model/api/api';
import { Identities } from '../../../model/store/providers/Identities';
import Modal from 'react-modal';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { toaster } from '../../../model/toast/toaster';
import { Localization } from '../../../model/store/providers/Localization';
import './UnlinkAccountModal.scss';
import { LocalSystemConfig } from '../../../model/localSystems';

export type Props = {
	isOpen: boolean;
	system: LocalSystemConfig;
	localAccountId: string;
	closeModal: () => void;
};

const modalStyles = {
	overlay: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#00000066',
		outline: '0',
	}
};

// Requested by the Modal package. If it's not present, an error is logged.
const appElement = document.getElementById('root');

export const UnlinkAccountModal = ({ isOpen, system, localAccountId, closeModal }: Props) => {
	const [submitting, setSubmitting] = useState(false);
	const dispatch = useContext(Identities.Dispatch);
	const { translations } = useContext(Localization.State);
	const {
		unlinkAccountModal: {
			title,
			confirmation,
			yes,
			no,
			successToast
		},
		apiErrors
	} = translations;

	const onConfirm = useCallback(async () => {
		try {
			setSubmitting(true);

			await api.unlinkIdentity(system.id, localAccountId);

			dispatch({
				type: 'unlinkIdentity',
				systemId: system.id,
				localUserId: localAccountId
			});

			closeModal();

			toaster.success(`${localAccountId} ${successToast}`);
		}
		catch(error: any) {
			toaster.error(mapApiError(error, apiErrors));
		}
		finally {
			setSubmitting(false);
		}
	}, [dispatch, system, localAccountId, closeModal, successToast, apiErrors]);

	return <>
		<LoadingIndicator show={submitting} blockInteractions />
		<Modal
			className="unlink-account-modal"
			isOpen={isOpen}
			style={modalStyles}
			onRequestClose={closeModal}
			appElement={appElement!}
		>
			<span className="unlink-account-modal__header">{title}</span>
			<div className="unlink-account-modal__header-bar">
			</div>
			<span className="unlink-account-modal__body">
				<span className="unlink-account-modal__confirmation">
					{confirmation}: <span className="confirmation__local-id">{ localAccountId }</span>?
				</span>
				<div className="unlink-account-modal__controls">
					<button className="unlink-account-modal__confirm" onClick={onConfirm}>{yes}</button>
					<button className="unlink-account-modal__cancel" onClick={closeModal}>{no}</button>
				</div>
			</span>
		</Modal>
	</>;
}